import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Input from '../../inputs/Input';
import BtnSubmit from '../../buttons/BtnSubmit';
import { BackButton } from '../../buttons/BackButton';
import { useNavigate } from 'react-router-dom';

export default function TestQuiz() {
   
   const [data, setdata] = useState( JSON.parse(localStorage.getItem("test-quiz")) );
   const baseUrl = process.env.REACT_APP_API_URL;
   const navigate  = useNavigate();
   // const [answer, setanswer] = useState( Array.isArray(data)? 
   
   // (data[999999] ? data[data[999999].id] : data[0])
   //    :  
   //  (Object.values(data)[999999] ? 
   //    Object.values(data)[Object.values(data)[999999].id]  
   //    : Object.values(data)[0] ) );


      const [answer, setanswer] = useState( data[999999] ? data[data[999999].id] : Object.values(data)[0] );
   const [connectors, setconnectors] = useState();
   const [rightElem, setrightElem ] = useState();
   const [cliked, setcliked] = useState(0);
   const [convProgressId, setconvProgressId] = useState(  localStorage.getItem("test-quiz-progress"));
   const [currentAnswer, setcurrentAnswer] = useState( data[999999] );
   const [textFromUser, setTextFromUser] = useState();
   useEffect(()=>{
      console.log( answer);
      axios.get(baseUrl+'/appi/quiz/test/connectors/'+ answer.id, { withCredentials: true })
      .then(response=>{
        
         setconnectors(response.data);
         
      })
      .catch(error => {

      });
   },[answer])

   const onClickHundler = (elem) =>{
      if(cliked != 1){
         
         setcliked(1);
         let nexId = elem.getAttribute('data-key');
         let isRight = elem.getAttribute('data-isright');
         let connectorId = elem.getAttribute('data-elid');
         let textToFill = elem.getAttribute('data-text');
         let txtfromUser = textFromUser;
         console.log(textToFill);
         console.log(txtfromUser);
         if(textToFill && txtfromUser){
            if(textToFill.trim().toLowerCase() === txtfromUser.trim().toLowerCase()){
               elem.style.background = "rgb(143, 255, 132)";
               elem.style.border = '3px solid rgb(31, 146, 21)';
               
            }else{
               elem.style.background = "rgb(214, 159, 137)";
               elem.style.border = '3px solid rgb(195, 70, 21)';
               
            }
            setrightElem(textToFill);
         }else{
            if(isRight == 1){
               elem.style.background = "green";
               triggerVibration([100]);
            }else{
               elem.style.background = "red";
               triggerVibration([350,50,100]);
            }
            
            connectors.forEach(element => {
               if(element.isRight.id === 1){
                setrightElem(element.text);
                
               }
             });
         }
         
        
   
   
         onSubmitChanges(convProgressId,connectorId,txtfromUser);
   
        
         //make a delay here to show right answer and wrong answers
         //--- start
         setTimeout(() => {
            axios.get(baseUrl+'/appi/quiz/test/connectors/'+ nexId, { withCredentials: true })
            .then(response=>{
         
               const foundInMapById = data[nexId];
            
            setanswer( foundInMapById); 
               setconnectors("");
               setcliked(0);
               
            })
            .catch(error => {
   
            });
         },2000);
         //--- end
      }
      

   }
   const onSubmitChanges = ((convProgressId,connectorId,name)=>{
      axios.post(baseUrl+'/appi/quiz/test/notify',
         JSON.stringify({convProgressId, connectorId, name}), {
             withCredentials: true,
             headers: {
                 'Content-Type': 'application/json',
             },
         }
     ).then(response=>{
      setTextFromUser(null);
     }).catch(error=>{})
   });
   const handlerInput = (text) => {
      console.log(text);
      setTextFromUser(text);
   }
   const triggerVibration = (time) => {
      if ("vibrate" in navigator) {
        navigator.vibrate(time); 
      } 
    };
   const replaceGap= (textfrom,text) => {
     let res = '';
     if(textfrom){
      if(textfrom.includes("______")){
         res = textfrom.replace("______",text);
        }else if(textfrom.includes("_____")){
         res = textfrom.replace("_____",text);
        }else if(textfrom.includes("____")){
         res = textfrom.replace("____",text);
        }
     }
    
      return res; 
   }
  return (
    <div className='test-quiz-container'>
      <h2>{
        answer['text'].includes(":") ?  answer['text'].split(":")[0] : ( answer['text'].split("!")[0] ) }:</h2>
      <h1><span className='sp-bd'>
         [</span>{answer['text'].includes(":") ? answer['text'].split(":")[1] : (cliked === 1 ? (replaceGap(answer['text'].split("!")[1],rightElem) ) : ( answer['text'].split("!")[1] ) ) } 
         <span className='sp-bd'>]
            </span></h1>
      <div className='test-quiz-block'>
      { Array.isArray(connectors) ? 
             ( connectors.map(item => (
            
               item.clasification ?

                <div style={{display:'flex',justifyContent:'center',flexDirection:'column'}}>
                   <Input className="s-inp" hint="Напиши тут слово.." onListenner={handlerInput} />
                   <div className='s-btn' onClick={(e) => onClickHundler(e.currentTarget)}
                    key={item.nextId.id} 
                    data-key={item.nextId.id} 
                    data-elid={item.id}
                    data-text={item.text} 
                    data-isright={item.isRight.id} 
                  
                   >Зберегти</div>
                  </div> 
               :

               <div onClick={(e) => onClickHundler(e.currentTarget)} className='test-quiz-button' 
               key={item.nextId.id} 
               data-key={item.nextId.id} 
               data-elid={item.id}
               data-isright={item.isRight.id} 
               style={{
                  background:(  cliked === 0 ? 'transparent' :  item.isRight.id === 1 ? 'rgb(164, 247, 157)' : 'rgb(249, 157, 121)'),
                  border:(  cliked === 0 ? ' 3px solid rgba(180, 206, 250, 0.93)' :  item.isRight.id === 1 ? '3px solid rgb(150, 239, 142)' : ' 3px solid rgba(246, 141, 100, 0.94)'),
                }}
               >{item.text}</div> ))
             )  
             : ('') }
      </div>
  
      <BackButton onClick={() => navigate(-1)} />
    </div>
  )
}